
export default function toggleArray<T = string | number>(array: Array<T>, value: T): Array<T> {
  const set = new Set<T>(array);

  set.has(value) ? 
    set.delete(value) : 
    set.add(value);

  return Array.from(set);
}